import styled, { css } from "styled-components";
import { TableCell } from "@mui/material";

interface StyledTableCellProps {
    $noEllipsis?: boolean;
}

const StyledTableCell = styled(TableCell)<StyledTableCellProps>`
    height: 40px;

    ${(props) =>
        props.$noEllipsis &&
        css`
            overflow: initial !important;
            text-overflow: initial !important;
            white-space: initial !important;
        `};
`;

StyledTableCell.defaultProps = {
    $noEllipsis: false,
};

export default StyledTableCell;
